import { environment } from "../../../environments/environment";

export interface NavigationChannelConfig {
  channelId: string;
  siteName: string;
  routePrefix?: string;
}

/**
 * Resolves the configured CoreMedia channel (channelId + expected site name for X-Site-Hash) for
 * the current country/language from environment.navigation.channels. Shared by every client that
 * needs the "current site" context (navigation, channel layout) — not content elements, whose
 * site can differ per item (see ContentStubDto.rootName).
 */
export function resolveNavigationChannel(
  country: string,
  language: string,
): NavigationChannelConfig | null {
  const channels = environment.navigation.channels as Record<
    string,
    Record<string, NavigationChannelConfig> | undefined
  >;
  const channel =
    channels[country.toLowerCase()]?.[language.toLowerCase()] ?? null;
  if (!channel || !channel.channelId) {
    return null;
  }
  return channel;
}
